import { render, staticRenderFns } from "./PhoneConfirm.vue?vue&type=template&id=8fba49ac&"
import script from "./PhoneConfirm.vue?vue&type=script&lang=js&"
export * from "./PhoneConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports